/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../../../core/error/error-name';
import FileSystemUnit from './file-system-unit';

/**
 * Triviální správce souborového systému pro webovou platformu.
 * @implements {FileSystemManager}
 * @memberof AdapterWeb
 */
class FileSystemManager {
  /** @inheritdoc */
  createDirectory(path) {
    return new Promise(() => {
      const error = new Error('Unable to create any directory.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  getAllUnits() {
    return Promise.resolve([new FileSystemUnit()]);
  }

  /** @inheritdoc */
  getDirectory(path) {
    return new Promise(() => {
      const error = new Error('No directory exists.');
      error.name = ErrorName.NotFoundError;
      throw error;
    });
  }

  /** @inheritdoc */
  getEntry(path) {
    return new Promise(() => {
      const error = new Error('No entry exists.');
      error.name = ErrorName.NotFoundError;
      throw error;
    });
  }

  /** @inheritdoc */
  getFile(path) {
    return new Promise(() => {
      const error = new Error('No file exists.');
      error.name = ErrorName.NotFoundError;
      throw error;
    });
  }

  /** @inheritdoc */
  getUnit(name) {
    return new Promise(() => {
      const error = new Error('No unit exists.');
      error.name = ErrorName.NotFoundError;
      throw error;
    });
  }

  /** @inheritdoc */
  hasDirectory(path) {
    return Promise.resolve(false);
  }

  /** @inheritdoc */
  hasEntry(path) {
    return Promise.resolve(false);
  }

  /** @inheritdoc */
  hasFile(path) {
    return Promise.resolve(false);
  }

  /** @inheritdoc */
  readFile(path) {
    throw new Error('not implemented');
  }

  /** @inheritdoc */
  writeFile(path, data) {
    throw new Error('not implemented');
  }
}

export default FileSystemManager;
